import { Navigate } from '@tanstack/react-router';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

export function Logout() {
  useDocumentTitle('Logging you out...');
  localStorage.clear();

  return <Navigate to='/' replace />;
}
